module.exports = __webpack_public_path__ + "img/31.8ae43401.jpg";